import styled from 'styled-components';

import { INPUT_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

import { NEUTRAL_COLORS, SEMANTIC_COLORS } from '../styles/colors';
import { TYPOGRAPHY } from '../Typography';

export const S = {
  Wrapper: styled.div<{
    variant: 'default' | 'fluid';
    disabled: boolean;
  }>`
    ${INPUT_RESET}

    width: 100%;
    opacity: ${(props) => (props.disabled ? 0.6 : 1)};
    position: relative;
  `,

  /* Above the input */
  TopSection: styled.div`
    padding-bottom: ${SPACING.size8};
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size4};
  `,

  Label: styled.label`
    ${TYPOGRAPHY.labelMediumRegularDense}
    color: ${NEUTRAL_COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
  `,

  FluidLabel: styled.label<{ $isFloating?: boolean }>`
    ${({ $isFloating }) =>
      $isFloating ? TYPOGRAPHY.labelXtraSmallRegular : TYPOGRAPHY.labelMediumMedium};

    color: ${NEUTRAL_COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    transition: all 0.2s ease;
    position: absolute;
    left: 16px;

    /* Always set position and transform, but vary the values based on $isFloating */
    top: ${({ $isFloating }) => ($isFloating ? '6px' : '28px')};
    transform: ${({ $isFloating }) => ($isFloating ? 'translateY(0)' : 'translateY(-50%)')};
  `,

  FluidLabelIcon: styled.div`
    padding-left: ${SPACING.size4};
    display: flex;
    align-items: center;
  `,

  Description: styled.p`
    ${TYPOGRAPHY.overlineMediumRegular}
    color: ${NEUTRAL_COLORS['cloud-900']};
  `,

  InputContainer: styled.div<{
    $state: 'success' | 'error' | 'idle' | 'disabled';
  }>`
    border-radius: 12px;
    border: 1px solid
      ${(props) => {
        switch (props.$state) {
          case 'success':
            return SEMANTIC_COLORS['success-900'];
          case 'error':
            return SEMANTIC_COLORS['danger-500'];
          case 'disabled':
          case 'idle':
            return NEUTRAL_COLORS['charcoal-alpha-50'];
        }
      }};

    background-color: ${NEUTRAL_COLORS['white-50']};
    padding-left: ${SPACING.size16};
    display: flex;
    align-items: center;
    margin-bottom: ${SPACING.size8};

    //  FIXME: Make focus-visible from accessibility perspective look better. Instead of default
    /* &:focus-within {
      outline: 2px solid #0066ff;
      outline-offset: 2px;
    } */
  `,

  Prefix: styled.p<{
    $isFocused: boolean;
  }>`
    ${TYPOGRAPHY.labelMediumRegular}
    color: ${(props) =>
      props.$isFocused ? NEUTRAL_COLORS['charcoal-500'] : NEUTRAL_COLORS['pebble-500']};
    padding-right: ${SPACING.size8};
  `,

  Input: styled.input<{
    $isFluid?: boolean;
  }>`
    ${TYPOGRAPHY.labelMediumMedium}
    flex: 1;
    min-width: 0;
    border: 0;
    background: transparent;
    text-overflow: ellipsis;
    color: ${NEUTRAL_COLORS['charcoal-500']};

    height: ${(props) => (props.$isFluid ? '42px' : '56px')};
    margin-top: ${(props) => (props.$isFluid ? SPACING.size12 : '0')};

    &::placeholder {
      color: ${NEUTRAL_COLORS['charcoal-300']};
    }

    // FIXME: Make focus-visible from accessibility perspective look better. Instead of default
    &:focus-visible {
      outline: none;
      border: 0;
    }
  `,

  SuffixWrapper: styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: auto;
  `,

  Suffix: styled.p`
    ${TYPOGRAPHY.labelMediumRegular}
    color: ${NEUTRAL_COLORS['charcoal-300']};
    padding-right: ${SPACING.size16};
    text-align: right;
  `,

  BottomSection: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    padding-left: ${SPACING.size12};
    height: 12px;
  `,

  HelperText: styled.p<{ $validationState: 'success' | 'error' | 'idle' }>`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${(props) => {
      switch (props.$validationState) {
        case 'success':
          return SEMANTIC_COLORS['success-900'];
        case 'error':
          return SEMANTIC_COLORS['danger-500'];
        default:
          return NEUTRAL_COLORS['pebble-500'];
      }
    }};
  `
};
